import Reveal from "@/components/Reveal";
import { scrollToSection } from "@/data/catalog";
import { ArrowUpRight } from "lucide-react";

export default function CtaBand() {
  return (
    <section data-testid="cta-band" className="relative overflow-hidden border-t border-[#1F1F1F] bg-[#050505] py-20 lg:py-24">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[300px] w-[640px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#E11D2E]/[0.07] blur-[120px]" />
      <div className="relative mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-8 px-6 lg:px-10">
        <Reveal>
          <h2 className="max-w-xl font-display text-3xl uppercase leading-[1.05] tracking-tight text-white sm:text-4xl">
            Ready to take <span className="text-[#E11D2E]">your brand</span> to the next level?
          </h2>
          <p className="mt-3 text-sm text-[#8A8A8A] md:text-base">Let's build your empire. Contact us today.</p>
        </Reveal>
        <Reveal delay={0.1} className="flex flex-wrap gap-4">
          <button
            data-testid="cta-get-started"
            onClick={() => scrollToSection("#pricing")}
            className="group flex items-center gap-2 bg-[#E11D2E] px-7 py-4 font-mono text-xs font-600 uppercase tracking-[0.14em] text-white transition-all duration-300 hover:bg-[#F13B47] hover:shadow-[0_0_32px_rgba(225,29,46,0.4)]"
          >
            Get started
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <button
            data-testid="cta-contact"
            onClick={() => scrollToSection("#contact")}
            className="border border-[#333333] px-7 py-4 font-mono text-xs font-600 uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:border-[#E11D2E]"
          >
            Contact us
          </button>
        </Reveal>
      </div>
    </section>
  );
}
